<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>후원 활동 관리</strong></div>
			<h2 class="h_sub">후원 활동 리스트</h2>
		</div>

    <SponsorManageCreateForm/>
  </div>
</template>

<script>
import SponsorManageCreateForm from '@/components/admin/board/SponsorManageCreateForm.vue';

export default {
  components: {
    SponsorManageCreateForm
  }
    
}
</script>
<style lang="">
    
</style>